import BaseModelLoader from "./BaseModelLoader";

class GenericModelLoader extends BaseModelLoader {
  async reloadTextures(positions) {
    if (!Array.isArray(positions)) {
      return;
    }

    for (const position of positions) {
      const key = this._makeKey(position);
      const inst = this.instances.get(key);
      if (!inst) continue;

      await this.applyTextureToInstance(inst, position);
    }
  }

  _loadTexture(url) {
    return new Promise((resolve, reject) => {
      const loader = new THREE.TextureLoader();
      loader.load(url, texture => {
        resolve(texture);
      }, undefined, err => reject(err));
    });
  }

  async applyTextureToInstance(inst, data) {
    if (!data.texture_url) return;

    const texture = await this._loadTexture(data.texture_url);
    texture.rotation = window.THREE.MathUtils.degToRad(data.texture_rotation || 0);
    texture.wrapS = window.THREE.MirroredRepeatWrapping;
    texture.wrapT = window.THREE.MirroredRepeatWrapping;
    texture.repeat.set(2, 2);

    texture.needsUpdate = true;
    texture.encoding = window.THREE.SRGBColorSpace;

    inst.traverse(child => {
      if (child.isMesh) {
        child.material = new window.THREE.MeshPhysicalMaterial({
          map: texture,
          color: 0xffffff,
          roughness: 0.2,
          metalness: 0.0,
          clearcoat: 0,
          clearcoatRoughness: 0.05,
          reflectivity: 0.1,
          envMapIntensity: 0.1
        });
        child.material.color.setScalar(0.2);
        child.material.needsUpdate = true;
      }
    });
  }
}

export default GenericModelLoader
